import { TIncident, TAlert } from '@core/modules/mdr/cases'
import { TabContent, Label } from './caseTabCommunication.styles'

interface Props {
    data: TIncident | TAlert
}

const CaseTabCommunication = ({ data }: Props) => {
    return (
        <TabContent data-testid="communication-content">
            <Label>Coming Soon</Label>
        </TabContent>
    )
}

export default CaseTabCommunication
